//Initialize sandbox
AAcom('browserdetect', 'commonsetup', 'utilities', 'loyaltyInformation', 'ajax', (AAUI) => {

    AAUI.updateConsent = function() {
        const consentRules = AAUI.getConsentRules();

        AAUI.updateCoppaMessage(consentRules.isMinor);
        AAUI.updateConsentCheckbox(consentRules);
    };

    AAUI.updateCoppaMessage = function(isMinor) {
        const $coppaMessage = $j('#coppaDisclaimerMessage');

        if (isMinor) {
            $coppaMessage.show();
        } else {
            $coppaMessage.hide();
        }
    };

    AAUI.updateConsentCheckbox = function(consentRules) {
        if (AAUI.getUrlParameter('from') !== 'ssocp') {
            const $mainConsentCheckboxText = $j('#emailConsentText');
            const $secondaryConsentCheckboxText = $j('#emailConsentSubscriptionText');
            const $consentPrefCheckbox = $j('#emailConsentForm\\.acceptEmailConsentTermAndConditions');

            if (consentRules.isMinor) {
                $mainConsentCheckboxText.html(AAcom.prototype.getProperty('minorConsentText'));
                $secondaryConsentCheckboxText.html('');
                $consentPrefCheckbox.prop('checked', consentRules.permissiveMinor);
            } else {
                $mainConsentCheckboxText.html(AAcom.prototype.getProperty('adultConsentText'));
                $secondaryConsentCheckboxText.html(AAcom.prototype.getProperty('adultConsentSubscriptionText'));
                $consentPrefCheckbox.prop('checked', consentRules.permissiveAdult);
            }
        }
    };

    AAUI.showChineseTermsAndConditions = function(value) {
        const userLocale = AAcom.prototype.getProperty('user.locale');
        const language = userLocale.substring(0, 2);
        const country = userLocale.substring(3, 5);

        return ((value === 'CN' || value === 'HK')
            && (userLocale === 'en_US' || userLocale === 'es_US' || language === 'zh' || country === 'CN' || country === 'HK'));
    };

    AAUI.initUpdateTermsAndConditions = function() {
        AAUI.onChange('select[name="addressInformationForm.country"]', function() {
            if (AAUI.showChineseTermsAndConditions($j(this).val())) {
                $j('#tcpart2').text(AAUI.getProperty('chineseTAndCText'));
                $j('#acceptTermAndConditions').prop('checked', false);
            } else {
                $j('#tcpart2').text(AAUI.getProperty('nonChineseTAndCText'));
            }
        });
    };

    AAUI.initUpdateTermsAndConditionsOnPageLoad = function() {
        if (AAUI.showChineseTermsAndConditions($j('select[name="addressInformationForm.country"]').val())) {
            $j('#tcpart2').text(AAUI.getProperty('chineseTAndCText'));
        }
    };

    AAUI.initPersonalInfoForm = function() {
        AAUI.onChange('.js-change-dob', function() {
            AAUI.updateConsent();
        });
    };

    AAUI.initAddressForm = function() {
        AAUI.onChange('#addressInformationForm\\.country', function() {
            AAUI.updateConsent();
        });
    };

    AAUI.initPageSubmit = function() {
        const savingTxt = AAUI.getProperty('loadingTxt');
        AAUI.onSubmit('#enrollmentInformationForm', function () {
            if ($j('body').aaBusy({ message: savingTxt, form: this }).start()) {
                return false;
            }
        });
    };

    AAUI.onClick('#continueButton',function() {
        var addressType = $j('input[name="addressInformationForm.addressType"]:checked').val();
        if (addressType == 'HOM') {
            $j('#addressInformationForm\\.businessName').val('');
        }
        $j("#enrollmentInformationForm").submit();
    });

    AAUI.initUpdateConsentOnPageLoad = function() {
        const country = $j('#addressInformationForm\\.country').val();
        if (country != undefined && country != null && country !== '') {
            AAUI.updateConsent();
        }
    };

    AAUI.initFocusOnErrors = function (){
        jQuery("p, a").each( (i, element) => {
            var $element = jQuery(element);
            if($element.is("[id*='globalErrorSummaryLink']") && $element.is(":visible")) {
                $j('html,body').animate({scrollTop: $element.parent().offset().top - 80});
                $element.focus();

                return false;
            }
        });
    };

    AAUI.initPage = function(pageLoad) {
        pageLoad = pageLoad || false;

        if (pageLoad) {
            AAUI.initLoyaltyInformation();
            AAUI.initPersonalInfoForm();
            AAUI.initAddressForm();
            AAUI.initPageSubmit();
            AAUI.initFocusOnErrors();
            AAUI.initUpdateTermsAndConditions();
            AAUI.initUpdateTermsAndConditionsOnPageLoad();
            AAUI.initUpdateConsentOnPageLoad();
        }
    };

    $j(document).ready(function() {
        AAUI.initPage(true);
    });
});
